/***************************************************
Alexander Self
6/27/17
Misc reducer: Handles data used by multiple modules
Map reducer: Handles all map interactions
****************************************************/
import { FETCH_PAY_PERIOD, UNAUTH_USER, SET_MAP_VIEW, SET_FIELD_VIEW,
  SET_MAP_LOCATION, FETCH_FIELD_INFORMATION, FETCH_POSITION_TYPE } from '../actions/types';
const initState = {
  payPeriod: {},
  prevPP: {},
  season: {},
  positionTypes: [],
  mapView: false,
  location: 'kau',
  field: null,
  fieldInfo: {
    basicInfo: {},
    blocks: [],
    harvest: {},
    work: {},
    lastVisited: {}
  }
};

export default function MiscReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_PAY_PERIOD:
      return { ...state,
        payPeriod: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate
        },
        prevPP: {
          startDate: action.prevPP.startDate,
          endDate: action.prevPP.endDate
        }
      };
    case FETCH_FIELD_INFORMATION:
      return { ...state,
        fieldInfo: {
          basicInfo: action.payload.fieldInfo,
          blocks: action.payload.blocks,
          harvest: action.payload.harvestObj,
          work: action.payload.workObj,
          lastVisited: action.payload.lastVisited
        }
      };
    case SET_MAP_VIEW:
      let field;
      field = state.field;
      /* Make sure field is not displaying when on Dashboard */
      if (state.mapView === true) {
        field = null;
      }
      return { ...state,
        field,
        mapView: !state.mapView
      };
    case SET_FIELD_VIEW:
      return { ...state,
        field: action.payload
      };
    case SET_MAP_LOCATION:
      return { ...state,
        location: action.payload
      };
    case FETCH_POSITION_TYPE:
      return { ...state,
        positionTypes: action.payload
      };
    case UNAUTH_USER:
      return initState;
    default:
      return state;
  }
}






















/* END */



// WEBPACK FOOTER //
// ./src/reducers/misc_reducer.js